module.exports = __webpack_public_path__ + "img/wallet_03_multi.c985a261.png";